import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const CensusStepSectionStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  margin: 0 auto 6.4rem;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
